import React from 'react';
import ActionButton from '../../../elements/ActionButton';
import Icon from '../../../elements/icons/Icon';
import emailIcon from '../../../../resources/icons/E_mail_icon.png';
import { useI18n } from '../../../../data/hooks/i18nHooks';

function EmailContactButton(props) {
    const { className = '', user } = props,
        i18n = useI18n();

    if (!user.is_contact) return null;
    if (!user.allow_email) return null;

    return (
        <ActionButton
            className={className}
            icon={<Icon src={emailIcon} size={40} />}
            href='./email'
            next>
            {i18n['label.email.send']}
        </ActionButton>
    );
}

export default EmailContactButton;
